// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3cf2f673","453":"d60b158d","455":"596d1b19"}[chunkId] + ".chunk.js";
};